<app-paginator
	#p
	[mfTable]="mfTable"
>
	@if (p.dataLength > p.rowsOnPage) {
	<ul class='pagination'>
		<li
			class='page-item'
			[class.disabled]='p.activePage <= 1'
			(click)='p.setPage(1)'
		>
			<a class='page-link'>&laquo;</a>
		</li>

		@if (p.activePage > 4 && p.activePage + 1 > p.lastPage) {
		<li
			class='page-item'
			(click)='p.setPage(p.activePage - 4)'
		><a class='page-link'>{{p.activePage-4}}</a></li>
		}
		@if (p.activePage > 3 && p.activePage + 2 > p.lastPage) {
		<li
			class='page-item'
			(click)='p.setPage(p.activePage - 3)'
		><a class='page-link'>{{p.activePage-3}}</a></li>
		}
		@if (p.activePage > 2) {
		<li
			class='page-item'
			(click)='p.setPage(p.activePage - 2)'
		><a class='page-link'>{{p.activePage-2}}</a></li>
		}
		@if (p.activePage > 1) {
		<li
			class='page-item'
			(click)='p.setPage(p.activePage - 1)'
		><a class='page-link'>{{p.activePage-1}}</a></li>
		}

		<li class='page-item active'><a class='page-link'>{{p.activePage}}</a></li>

		@if (p.activePage + 1 <=
			p.lastPage)
			{
			<li
			class='page-item'
			(click)='p.setPage(p.activePage + 1)'
		><a class='page-link'>{{p.activePage+1}}</a></li>
			}
			@if (p.activePage + 2 <=
				p.lastPage)
				{
				<li
				class='page-item'
				(click)='p.setPage(p.activePage + 2)'
			><a class='page-link'>{{p.activePage+2}}</a></li>
				}
				@if (p.activePage + 3 <=
					p.lastPage
					&&
					p.activePage
					<
					3)
					{
					<li
					class='page-item'
					(click)='p.setPage(p.activePage + 3)'
				><a class='page-link'>{{p.activePage+3}}</a></li>
					}
					@if (p.activePage + 4 <=
						p.lastPage
						&&
						p.activePage
						<
						2)
						{
						<li
						class='page-item'
						(click)='p.setPage(p.activePage + 4)'
					><a class='page-link'>{{p.activePage+4}}</a></li>
						}

						<li
							class='page-item'
							[class.disabled]='p.activePage >= p.lastPage'
							(click)='p.setPage(p.lastPage)'
						>
							<a class='page-link'>&raquo;</a>
						</li>
	</ul>
	}
</app-paginator>